import React from 'react';
import PropTypes from 'prop-types';

function IconAdd({ color = '#808080', size = 24, className }) {
  return (
    <svg  id={'icon-add'} width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.5 10.75C13.3619 10.75 13.25 10.6381 13.25 10.5V5H10.75V10.5C10.75 10.6381 10.6381 10.75 10.5 10.75H5V13.25H10.5C10.6381 13.25 10.75 13.3619 10.75 13.5V19H13.25V13.5C13.25 13.3619 13.3619 13.25 13.5 13.25H19V10.75H13.5Z" fill={color}/>
    </svg>
  )
}

IconAdd.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconAdd;
